import { Separator as SeparatorPrimitive } from '@base-ui/react/separator';
import { type VariantProps } from 'class-variance-authority';
import type { ReactNode } from 'react';

import { cn } from '../../lib/utils';
import {
  separatorLabelVariants,
  separatorVariants,
  separatorWrapperVariants,
} from './variants';

type SeparatorProps = SeparatorPrimitive.Props &
  Pick<VariantProps<typeof separatorVariants>, 'variant'> & {
    label?: ReactNode;
  };

function Separator({
  className,
  orientation = 'horizontal',
  variant = 'solid',
  label,
  ...props
}: SeparatorProps) {
  if (label !== undefined && orientation === 'horizontal') {
    return (
      <div
        data-slot={'separator'}
        data-orientation={'horizontal'}
        className={cn(separatorWrapperVariants(), className)}
        {...props}
      >
        <SeparatorPrimitive
          orientation={'horizontal'}
          className={cn(separatorVariants({ variant, mode: 'flex' }))}
        />
        <span
          data-slot={'separator-label'}
          className={cn(separatorLabelVariants())}
        >
          {label}
        </span>
        <SeparatorPrimitive
          orientation={'horizontal'}
          className={cn(separatorVariants({ variant, mode: 'flex' }))}
        />
      </div>
    );
  }

  return (
    <SeparatorPrimitive
      data-slot={'separator'}
      orientation={orientation}
      className={cn(
        separatorVariants({ variant, mode: 'standalone' }),
        className
      )}
      {...props}
    />
  );
}

export { Separator };
